// @ts-nocheck
// import pageTitleProps from "@store/Themes/common/props/pageTitle"; // Store Custom Code
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ResetPasswordPageContext } from "@insite/content-library/Pages/ResetPasswordPage";
import Typography from "@insite/mobius/Typography/Typography";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code - Start */
import pageTitleProps from "@store/Themes/common/props/pageTitle";
/* Store Custom Code - End */

const PageTitle = getWidgetComponent("Basic/PageTitle");

const ResetPasswordTitle: FC = () => {
    const location = useSelector((state: ApplicationState) => getLocation(state));

    const [isResettingPassword, setIsResettingPassword] = useState(true);
    const parsedQuery = parseQueryString<{ userName?: string; resetToken?: string; reset?: string }>(location.search);

    const textProps = {
        ...pageTitleProps,
        css: css`
            ${pageTitleProps.css}
        `,
    };

    useEffect(() => {
        setIsResettingPassword(parsedQuery.reset?.toLowerCase() === "true");
    }, []);

    if (isResettingPassword) {
        return <PageTitle />;
    }

    return <Typography {...textProps}>{translate("Account Activation")}</Typography>;
};

const widgetModule: WidgetModule = {
    component: ResetPasswordTitle,
    definition: {
        displayName: "Reset Password Title",
        allowedContexts: [ResetPasswordPageContext],
        group: "Reset Password",
    },
};

export default widgetModule;
